// import React, { Component } from 'react'
// import { Link } from "react-router-dom";
// import LogOut from "../components/LogOut";
// import back from "../assets/back.png";

// export class SEOUpdate extends Component {
//   render() {
//     return (
// <div className="seo-page">
//         {/* Navbar */}
//         <nav className="seo-navbar">
//           <h1 className="nav-title">اضافة تقرير تحسين محرك البحث

//             <br></br>
//             <br></br>

//             اسم العميل
//           </h1>
//           <LogOut />
//           <button className="add1">
//             <Link to="/admin">العودة للرئيسية</Link>
//           </button>
//           <button className="add2">
//             <Link to="/seo">رجوع </Link>
//           </button>
//         </nav>

//         {/* Page Content */}
//         <div className="admin_area">

//         </div>

//       </div>
//     )
//   }
// }

// export default SEOUpdate

import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import LogOut from "../components/LogOut";
import editnumber from "../assets/pen-number.png";
import trashicon from "../assets/trash.png";

export default function SEOUpdate() {
  const location = useLocation();
  const { brandName, seoId } = location.state || {};

  const [sections, setSections] = useState([
    { title: "", description: "", image: null },
  ]);
  const [showPopup, setShowPopup] = useState(false);
  const [analyses, setAnalyses] = useState([]);
  const [editPopup, setEditPopup] = useState(null);
  const [editForm, setEditForm] = useState({
    title: "",
    description: "",
    image: null,
  });

  // جلب البيانات من API
  const fetchSeoAnalyses = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(
        "http://backend.goldensection.agency/public/api/getuser",
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      const data = await res.json();

      if (data.users && data.users.length > 0) {
        const user = data.users.find((u) =>
          u.seo.some((seo) => seo.id === seoId),
        );
        if (user) {
          const seo = user.seo.find((s) => s.id === seoId);
          setAnalyses(seo.analyses || []);
        }
      }
    } catch (err) {
      console.error("Error fetching analyses:", err);
    }
  };

  useEffect(() => {
    fetchSeoAnalyses();
  }, [seoId]);

  // إضافة سيكشن جديد
  const handleAddSection = () => {
    setSections([...sections, { title: "", description: "", image: null }]);
  };

  // تغيير القيم
  const handleChange = (index, field, value) => {
    const newSections = [...sections];
    newSections[index][field] = value;
    setSections(newSections);
  };

  // حفظ البيانات الجديدة
  const handleSave = async () => {
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();

      sections.forEach((s, i) => {
        formData.append(`seos[${i}][seo_id]`, seoId);
        formData.append(`seos[${i}][title]`, s.title);
        formData.append(`seos[${i}][description]`, s.description);
        if (s.image) {
          formData.append(`seos[${i}][image]`, s.image);
        }
      });

      await fetch("http://backend.goldensection.agency/public/api/addseoAna", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      setShowPopup(false);
      setSections([{ title: "", description: "", image: null }]);
      fetchSeoAnalyses();
    } catch (err) {
      console.error("Error saving SEO analyses:", err);
    }
  };

  // حذف
  const handleDelete = async (id) => {
    if (!window.confirm("هل انت متأكد من الحذف؟")) return;
    try {
      const token = localStorage.getItem("token");
      await fetch(
        `http://backend.goldensection.agency/public/api/deleteseoAna/${id}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      fetchSeoAnalyses();
    } catch (err) {
      console.error("Error deleting analysis:", err);
    }
  };

  // تعديل
  const handleEditClick = (analysis) => {
    setEditPopup(analysis.id);
    setEditForm({
      title: analysis.title,
      description: analysis.description,
      image: null,
    });
  };

  const handleEditSave = async () => {
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("title", editForm.title);
      formData.append("description", editForm.description);
      if (editForm.image) {
        formData.append("image", editForm.image);
      }

      await fetch(
        `http://backend.goldensection.agency/public/api/updateseoAna/${editPopup}`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        },
      );

      setEditPopup(null);
      fetchSeoAnalyses();
    } catch (err) {
      console.error("Error updating analysis:", err);
    }
  };

  return (
    <div className="seo-page">
      {/* Navbar */}
      <nav className="seo-navbar">
        <h1 className="nav-title">
          اضافة تقرير تحسين محرك البحث <br />
          <br />
          {brandName}
        </h1>
        <LogOut />
        <button className="add1">
          <Link to="/admin">العودة للرئيسية</Link>
        </button>
        <button className="add2">
          <Link to="/seo">رجوع</Link>
        </button>
        <button className="add4" onClick={() => setShowPopup(true)}>
          إضافة محتوى
        </button>
      </nav>

      {/* جدول البيانات */}
      <div className="admin_area">
        <table className="users-table">
          <thead>
            <tr>
              <th>رقم السيكشن</th>
              <th>المحتوى</th>
              <th>الإجراءات</th>
            </tr>
          </thead>
          <tbody>
            {analyses.map((a, index) => (
              <tr key={a.id}>
                <td>{index + 1}</td>
                <td>
                  <strong>{a.title}</strong>
                  <p>{a.description}</p>
                  {a.image && (
                    <img
                      src={`http://backend.goldensection.agency/public/api/${a.image}`}
                      alt={a.title}
                      style={{ width: "100px", height: "auto" }}
                    />
                  )}
                </td>
                <td>
                  <button
                    className="delete-btn"
                    onClick={() => handleEditClick(a)}
                  >
                    <img src={editnumber} alt="edit" />
                  </button>
                  <button
                    className="delete-btn"
                    onClick={() => handleDelete(a.id)}
                  >
                    <img src={trashicon} alt="delete" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Popup الإضافة */}
      {showPopup && (
        <div className="popup-overlay">
          <div
            className="popup"
            style={{ maxHeight: "80vh", overflowY: "auto" }}
          >
            <button className="cancel-btn" onClick={() => setShowPopup(false)}>
              ×
            </button>
            <h3>إضافة محتوى</h3>
            {sections.map((s, index) => (
              <div key={index} className="section-form">
                <h4>سيكشن {index + 1}</h4>
                <label>العنوان</label>
                <input
                  type="text"
                  value={s.title}
                  onChange={(e) => handleChange(index, "title", e.target.value)}
                />
                <label>الوصف</label>
                <input
                  type="text"
                  value={s.description}
                  onChange={(e) =>
                    handleChange(index, "description", e.target.value)
                  }
                />
                <label>الصورة</label>
                <input
                  type="file"
                  onChange={(e) =>
                    handleChange(index, "image", e.target.files[0])
                  }
                />
              </div>
            ))}
            <button className="add5" onClick={handleAddSection}>
              إضافة سيكشن جديد
            </button>
            <button className="save-btn" onClick={handleSave}>
              حفظ
            </button>
          </div>
        </div>
      )}

      {/* Popup التعديل */}
      {editPopup && (
        <div className="popup-overlay">
          <div
            className="popup"
            style={{ maxHeight: "80vh", overflowY: "auto" }}
          >
            <button className="cancel-btn" onClick={() => setEditPopup(null)}>
              ×
            </button>
            <h3>تعديل المحتوى</h3>
            <label>العنوان</label>
            <input
              type="text"
              value={editForm.title}
              onChange={(e) =>
                setEditForm({ ...editForm, title: e.target.value })
              }
            />
            <label>الوصف</label>
            <input
              type="text"
              value={editForm.description}
              onChange={(e) =>
                setEditForm({ ...editForm, description: e.target.value })
              }
            />
            <label>الصورة</label>
            <input
              type="file"
              onChange={(e) =>
                setEditForm({ ...editForm, image: e.target.files[0] })
              }
            />
            <button className="save-btn" onClick={handleEditSave}>
              حفظ
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
